<template>
		<div class="account-notifications">
			<span class="fa fa-envelope-o">
							<!-- SVG ARROW -->
							<svg class="svg-arrow">
								<use xlink:href="#svg-arrow"></use>
							</svg>
							<!-- /SVG ARROW -->
						</span>

			<!-- PIN -->
			<span class="pin soft-edged secondary" v-if="messagesUnread" v-text="messagesUnread"></span>
			<!-- /PIN -->

			<!-- DROPDOWN NOTIFICATIONS -->
			<ul class="dropdown notifications closed">
				<!-- DROPDOWN ITEM -->
				<div class="dropdown-triangle"></div>

				<li  v-for="notification in notifications" :key="notification.id" :class="{ 'dropdown-item unread' : isUnread(notification), 'dropdown-item' : !isUnread(notification) }">
					<a :href="'/orders/' + notification.data_object.hash_id" class="link-to"></a>
					<figure class="user-avatar">
						<img :src="notification.data_object.avatar">
					</figure>
					<p class="text-header tiny title">
						<span v-if="notification.data_object.title.length<=35" v-text="notification.data_object.title"></span>
						<span v-if="notification.data_object.title.length>35" v-text="notification.data_object.title.substring(0,35)+'...'"></span>
					</p>
					<p v-if="notification.data_object.comment.length<=30" class="subject" v-text="notification.data_object.comment"></p>
					<p v-if="notification.data_object.comment.length>30" class="subject" v-text="notification.data_object.comment.substring(0,30)+'...'"></p>
					<p class="timestamp">{{notification.created_at | fromNowAgo }}</p>

					<span class="notification-type fa fa-envelope-open-o" v-if="notification.read_at !== null"></span>
					<span class="notification-type secondary-new fa fa-envelope-o" v-else></span>
				</li>

				<li v-if="!notifications.length"  class="dropdown-item empty">
					<a href="/orders/" class="link-to"></a>
					<p class="text-header tiny title">Your inbox is empty</p>
					<p class="sub-title">Place an order and communicate with writer</p>
				</li>
				<!-- /DROPDOWN ITEM -->



				<a href="/customer/dashboard/inbox" class="button secondary">View all Messages</a>



			</ul>
			<!-- /DROPDOWN NOTIFICATIONS -->
		</div>
</template>


<script>

    export default {
        data () {
            return {
                notifications: [],
				messagesUnread: false,
            }
		},

		created(){
            axios.get('/api/notifications?filter[unread]=true&filter[messages]=true&count=6')
					.then(response => {
						this.messagesUnread = response.data.total;
						this.notifications = response.data.data;

					});
		},


        methods: {
            isUnread: function (notification) {
                return notification.read_at == null
            },
        },


    }
</script>